<template>
  <el-dialog
    width="40%"
    class="dialog"
    title="发放失败"
    :visible.sync="dialogFormVisible"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"
    >
      <el-form-item label="失败原因" prop="failReason">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          v-model="formData.failReason"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >确认</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { failReasonReg } from "@/hooks/regex";

export default {
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      type: "add",
      formData: {
        subsidyNo: "",
        // 1-发放，2-发放成功，3-发放失败
        operateType: 3,
        failReason: ""
      },
      rules: {
        failReason: [
          { required: true, message: "请输入失败原因", trigger: "blur" },
          {
            pattern: failReasonReg,
            trigger: "blur",
            message: "请输入正确的失败原因"
          }
        ]
      },
      btnLoading: false
    };
  },
  watch: {
    dialogFormVisible: function(val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields();
      }
    }
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    openDialog(orderNo) {
      this.formData.subsidyNo = orderNo;
      this.dialogFormVisible = true;
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 确认发放失败
    async save() {
      let params = this.formData;
      this.HttpService.post(
        "/autoapp-default-server-recovery/api/oldMachineSubsidy/subsidyIssued",
        params
      ).then(res => {
        if (res.statusCode === 200) {
          this.$message.success("操作成功");
          this.dialogFormVisible = false;
          this.$emit('distributionFail')
        }
      });
    },
    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldMachineSubsidy/components/DistributionFailDialog.vue